import React, { useEffect, useRef, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import CrewCartItemOverView from "./CrewCartItemOverView.jsx";
import CrewCartMember from "./CrewCartMember.jsx";
import axios from "axios";

const ConfirmRemovePendingUser = ({rootUrl, userToken, crewCartToken, initiateCheckout, setShowConfirm, crewCart }) => {
    const { t } = useTranslation();
    const [countdown, setCountdown] = useState(5);
    const [isDisabled, setIsDisabled] = useState(false);
    const [selectedMembers, setSelectedMembers] = useState({});

    // Debug translations
    console.log('Translation test:', {
        membersReady: t('confirmDeletePendingUser.membersReady'),
        membersNotReady: t('confirmDeletePendingUser.membersNotReady')
    });

    const filteredCrewCart = {
        ...crewCart,
        members: crewCart?.members?.filter(member => member.status !== 'DONE') || []
    };

    const doneShopping = crewCart?.members?.filter(member => member.status === 'DONE') || [];

    console.log({doneShopping});
    useEffect(() => {
        setIsDisabled(true);
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    setIsDisabled(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        // Initialize all members as selected (to be included)
        const initialSelection = {};
        filteredCrewCart.members.forEach(member => {
            initialSelection[member.id] = true; // true means to be included
        });
        setSelectedMembers(initialSelection);

        return () => clearInterval(timer);
    }, [crewCart]);

    const toggleMemberSelection = (memberId) => {
        setSelectedMembers(prev => ({
            ...prev,
            [memberId]: !prev[memberId]
        }));
    };

    const continueCheckout = async function() {
        const membersToRemove = Object.entries(selectedMembers)
            .filter(([_, shouldInclude]) => !shouldInclude) // Changed to remove unchecked members
            .map(([memberId]) => memberId);

        let res = await axios.post(`${rootUrl}/api/crewcart/remove-pending`, {
            user_token: userToken,
            cart_token: crewCartToken,
            member_ids: membersToRemove
        });

        if(res.status == 200) {
            initiateCheckout();
        }
    }

    // Calculate number of unchecked members and their items
    const uncheckedMembers = Object.values(selectedMembers).filter(v => !v).length;
    const uncheckedItems = filteredCrewCart.members.reduce((acc, member) => {
        if (!selectedMembers[member.id]) {
            const memberItems = filteredCrewCart?.items?.filter(
                (item) => item.crew_cart_member_id === member.id
            ) || [];
            return acc + memberItems.reduce((sum, item) => sum + item.quantity, 0);
        }
        return acc;
    }, 0);

    return (
        <div className={"confirm-remove-pending-users"} style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100% - 20px)',
            background: '#fff',
            overflow: 'hidden',
        }}>
            {/* Header */}
            <div style={{
                padding: '20px',
                borderBottom: '1px solid #eee',
                background: '#fff'
            }}>
                <h5 className="h3-title-invite" style={{margin: 0}}>
                    {t('confirmDeletePendingUser.title')}
                </h5>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1" style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                position: 'relative',
                overflowY: 'auto'
            }}>
                <div className="crew-cart-checkout">
                    <div className="overview-container">
                        <div className="overview-header" style={{
                            display: 'grid',
                            gridTemplateColumns: '2fr 1fr 1fr 1fr',
                            alignItems: 'center',
                            fontWeight: 'normal',
                            color: '#666'
                        }}>
                            <span style={{ textAlign: 'left' }}>{t('confirmDeletePendingUser.add')}</span>
                            <span style={{ textAlign: 'center' }}>{t('overview.totalItems')}</span>
                            <span style={{ textAlign: 'right' }}>{t('overview.price')}</span>
                            <span style={{ textAlign: 'right' }}>{t('overview.total')}</span>
                        </div>
                        <div>
                            {/* Completed members section */}
                            {doneShopping.length > 0 && (
                                <>
                                    <div style={{
                                        padding: '15px 10px',
                                        backgroundColor: '#f8f9fa',
                                        borderBottom: '1px solid #eee',
                                        fontWeight: 'bold'
                                    }}>
                                        {t('confirmDeletePendingUser.membersReady')} ({doneShopping.length})
                                    </div>
                                    {doneShopping.map((member) => {
                                        const memberItems = crewCart?.items?.filter(
                                            (item) => item.crew_cart_member_id === member.id
                                        ) || [];
                                        const totalItems = memberItems.reduce((acc, item) => acc + item.quantity, 0);
                                        const totalPrice = memberItems
                                            .reduce((acc, item) => acc + parseFloat(item.price), 0)
                                            .toFixed(2);

                                        const discountedPrice = memberItems
                                            .reduce((acc, item) => acc + (item.discounted_price ? parseFloat(item.discounted_price) : 0), 0)
                                            .toFixed(2);

                                        return (
                                            <div key={member.id} className="overview-row" style={{
                                                display: 'grid',
                                                gridTemplateColumns: '2fr 1fr 1fr 1fr',
                                                alignItems: 'center',
                                                padding: '10px',
                                                borderBottom: '1px solid #eee',
                                                backgroundColor: '#f8f9fa'
                                            }}>
                                                <span>
                                                    <div className="member-info" style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px'
                                                    }}>
                                                        <CrewCartMember
                                                            name={member?.name}
                                                            status={member?.status}
                                                            size={35}
                                                        />
                                                        <span>{member?.name}</span>
                                                    </div>
                                                </span>
                                                <span style={{textAlign: 'center'}}>{totalItems} items</span>
                                                <span style={{textAlign: 'right'}}>
                                                    {discountedPrice > 0 ?
                                                        <strike>€{totalPrice}</strike> :
                                                        '€' + totalPrice}
                                                </span>
                                                <span style={{textAlign: 'right'}}>
                                                    {discountedPrice > 0 ?
                                                        '€' + discountedPrice :
                                                        '€' + totalPrice}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </>
                            )}

                            {/* Incomplete members section */}
                            {filteredCrewCart?.members?.length > 0 && (
                                <>
                                    <div style={{
                                        padding: '15px 10px',
                                        backgroundColor: '#fff',
                                        borderBottom: '1px solid #eee',
                                        fontWeight: 'bold'
                                    }}>
                                        {t('confirmDeletePendingUser.membersNotReady')} ({filteredCrewCart.members.length})
                                    </div>
                                    <div style={{
                                        padding: '10px',
                                        backgroundColor: '#fff',
                                        borderBottom: '1px solid #eee'
                                    }}>
                                        <span>{t('confirmDeletePendingUser.newDescription')}</span>
                                    </div>
                                    {filteredCrewCart?.members?.map((member) => {
                                        const memberItems = filteredCrewCart?.items?.filter(
                                            (item) => item.crew_cart_member_id === member.id
                                        ) || [];
                                        const totalItems = memberItems.reduce((acc, item) => acc + item.quantity, 0);
                                        const totalPrice = memberItems
                                            .reduce((acc, item) => acc + parseFloat(item.price), 0)
                                            .toFixed(2);

                                        const discountedPrice = memberItems
                                            .reduce((acc, item) => acc + (item.discounted_price ? parseFloat(item.discounted_price) : 0), 0)
                                            .toFixed(2);

                                        return (
                                            <div key={member.id} className="overview-row" style={{
                                                display: 'grid',
                                                gridTemplateColumns: '2fr 1fr 1fr 1fr',
                                                alignItems: 'center',
                                                padding: '10px',
                                                borderBottom: '1px solid #eee',
                                                opacity: selectedMembers[member.id] ? 1 : 0.5
                                            }}>
                                                <span>
                                                    <div className="member-info" style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px'
                                                    }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedMembers[member.id]}
                                                            onChange={() => toggleMemberSelection(member.id)}
                                                            style={{
                                                                width: '20px',
                                                                height: '20px',
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                        <CrewCartMember
                                                            name={member?.name}
                                                            status={member?.status}
                                                            size={35}
                                                        />
                                                        <span>{member?.name}</span>
                                                    </div>
                                                </span>
                                                <span style={{textAlign: 'center'}}>{totalItems} items</span>
                                                <span style={{textAlign: 'right'}}>
                                                    {discountedPrice > 0 ?
                                                        <strike>€{totalPrice}</strike> :
                                                        '€' + totalPrice}
                                                </span>
                                                <span style={{textAlign: 'right'}}>
                                                    {discountedPrice > 0 ?
                                                        '€' + discountedPrice :
                                                        '€' + totalPrice}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                    </div>

                    {/* Button Group - Fixed at bottom */}
                    <div className="checkout-button-container" style={{
                        padding: '20px',
                        borderTop: '1px solid #eee',
                        background: '#fff',
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        width: '100%',
                        marginTop: '10px',
                        zIndex: 10
                    }}>
                        <div className="button-group" style={{
                            display: 'flex',
                            gap: '2px',
                            justifyContent: 'center'
                        }}>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => {setShowConfirm(false)}}
                                style={{
                                    backgroundColor: 'white',
                                    border: '1px solid black',
                                    color: 'black',
                                    padding: '10px 20px',
                                    borderRadius: '0',
                                    flex: '1',
                                    maxWidth: '200px',
                                    height: '42px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {t('confirmDeletePendingUser.cancel')}
                            </button>

                            <button
                                className="btn rounded-0 done-shopping"
                                type="button"
                                onClick={continueCheckout}
                                disabled={isDisabled}
                                style={{
                                    flex: "1",
                                    maxWidth: "200px",
                                    padding: "10px 20px",
                                    height: "42px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "white",
                                    cursor: isDisabled ? "not-allowed" : "pointer"
                                }}
                            >
                                {isDisabled ? `${t("confirmDeletePendingUser.checkout")} (${countdown}s)` : (
                                    <>
                                        {t("confirmDeletePendingUser.checkout")} <span className="text-xl ml-2">→</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>


            </div>

            {uncheckedMembers > 0 && (
                <div style={{
                    padding: '15px 10px',
                    marginTop: '10px',
                    color: '#666'
                }}>
                    {t('confirmDeletePendingUser.removalWarning', {
                        members: uncheckedMembers,
                        items: uncheckedItems
                    })}
                </div>
            )}


        </div>
    );
}

export default ConfirmRemovePendingUser;
